export default {
  organization: undefined,
  organizations: [],
};
